import request from "./axios";

function index(params) {
  return request({
    method: "get",
    url: `/seminars`,
    params: params
  })
}

function get(id) {
  return request({
    method: "get",
    url: `/seminars/${id}`,
  })
}

function update(id, params) {
  return request({
    method: "patch",
    url: `/seminars/${id}`,
    data: { seminar: params }
  })
}

function create(params) {
  return request({
    method: "post",
    url: `/seminars`,
    data: { seminar: params }
  })
}

function openSeminars() {
  return request({
    method: "get",
    url: `/seminars/open_seminars_for_admin`
  })
}

const SeminarsService = {
  index, get, update, create, openSeminars
};

export default SeminarsService;
